import React from 'react';

const CatalogueIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">widgets</span>
            </>
      );
};

export default CatalogueIcon;
